import { render, staticRenderFns } from "./vault-group-card.vue?vue&type=template&id=5f8f346b"
import script from "./vault-group-card.vue?vue&type=script&lang=js"
export * from "./vault-group-card.vue?vue&type=script&lang=js"
import style0 from "./vault-group-card.vue?vue&type=style&index=0&id=5f8f346b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports